module.exports = __webpack_public_path__ + "static/img/4.1491335.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/4.png
// module id = Rkaq
// module chunks = 0